export default __webpack_public_path__ + "static/media/0675f27d165218073c58e2f2688b7c8e.svg";